import axios from 'axios'
import router from "@/router";
import { Message  } from "element-ui";
// 创建可一个新的axios对象
const request = axios.create({
    baseURL: process.env.VUE_APP_BASEURL,   // 后端的接口地址
    timeout: 30000
})

// request 拦截器
// 可以自请求发送前对请求做一些处理
// 比如统一加token，对请求参数统一加密
request.interceptors.request.use(config => {
    config.headers['Content-Type'] = 'application/json;charset=utf-8';
    let user = JSON.parse(localStorage.getItem("honey-user") || '{}');
    config.headers['token'] = user.token || ''  // 设置请求头

    return config
}, error => {
    console.error('request error: ' + error) // for debug
    return Promise.reject(error)
});

// response 拦截器
// 可以在接口响应后统一处理结果
request.interceptors.response.use(
    response => {
        const { config, data, headers } = response;
        if (
            config.responseType === 'blob' ||
            data instanceof Blob ||
            /application\/octet-stream/.test(headers['content-type'])
        ) {
            return response.data;
        }
        let res = response.data;
        if (typeof res === 'string') {
            // res = res ? JSON.parse(res) : res
        }
        if (res.code === '401') {
            router.push('/login')
        }
        if (res.code !== '200') {
            Message.error(res?.msg || '接口错误')
            return Promise.reject(res)
        }
        return res;
    },
    error => {
        console.error('response error: ' + error) // for debug
        return Promise.reject(error)
    }
)


export default request